import React from 'react';
import './Watermark.css';

const Watermark = () => {
  return (
    <div className="watermark">
   GT
    </div>
  );
};

export default Watermark;
